import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PermissionService } from 'app/core/services/permission.service';

@Component({
    selector: 'app-home',
    imports: [],
    templateUrl: './home.component.html',
    styleUrl: './home.component.scss',
})
export class HomeComponent implements OnInit {
    constructor(
        private permissionService: PermissionService,
        private router: Router
    ) {}

    ngOnInit(): void {
        if (this.permissionService.hasPermissions(['news_feed_read'])) {
            this.router.navigate(['newsfeed']);
        } else {
            this.router.navigate(['team/my-data']);
        }
    }
}
